import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export function PageHero({
	eyebrow,
	title,
	subtitle,
	actions,
	className,
}: {
	eyebrow?: string;
	title: string;
	subtitle?: string;
	actions?: React.ReactNode;
	className?: string;
}) {
	return (
		<div className={cn("container mx-auto px-4 pb-6 pt-10", className)}>
			{eyebrow && <p className="section-eyebrow mb-2">{eyebrow}</p>}
			<h1 className="font-display text-xl font-bold tracking-tight sm:text-2xl">
				{title}
			</h1>
			{subtitle && (
				<p className="mt-2 max-w-2xl text-sm text-muted-foreground">{subtitle}</p>
			)}
			{actions && <div className="mt-5 flex flex-wrap gap-2">{actions}</div>}
		</div>
	);
}

export function SoftLink({
	to,
	children,
}: {
	to: string;
	children: React.ReactNode;
}) {
	return (
		<Link
			to={to}
			className="inline-flex h-10 items-center rounded-xl border border-border/70 px-4 text-sm font-semibold hover:bg-card"
		>
			{children}
		</Link>
	);
}
